<template>
  <v-container fluid>
    <div class="toolbar d-flex flex-row justify-space-between align-center elevation-3 mb-3">
      <span>
        Lazada Return Order
      </span>
      <div class="d-flex">
        <v-select
          v-model="brandSelected"
          label="Brand"
          :items="allBrand"
          outlined
          dense
          class="mr-2"
          hide-details
          @change="getItems(true)" />
        <v-text-field
          v-model.trim="inputSearch"
          hide-details
          label="Search"
          append-icon="mdi-magnify"
          dense
          outlined
          @keydown.enter="getItems(true)">
        </v-text-field>
        <v-btn
          color="dark"
          size=""
          class="ml-2"
          :loading="loading"
          @click="showDialogSyncReturnOrder = true">
          <v-icon>
            mdi-sync
          </v-icon>
          Sync Return
        </v-btn>
      </div>
    </div>

    <v-row class="px-8">
      <v-col
        cols="12"
        class="card-container elevation-3">
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :items-per-page="options.itemsPerPage"
          :server-items-length="total"
          :loading="loading"
          :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
          @update:options="getItems()">
          <template #[`item.orderId`]="{ item }">
            <div> <b>Order ID : </b>{{ item.orderId }}</div>
            <div> <b>Lazada Order ID : </b>{{ item.lazadaOrderId }}</div>
          </template>
          <template #[`item.detail`]="{ item }">
            <div> <b>Return Reason : </b>{{ item.returnReasonText }} ({{ item.returnReason }})</div>
            <div> <b>Return Status : </b>{{ item.returnStatus }}</div>
            <div> <b>Return Type : </b>{{ item.requestType }}</div>
            <div> <b>Shipping Type : </b>{{ item.shippingType }}</div>
            <!-- <div>  : {{ item.lazadaOrderId }}</div> -->
          </template>
          <template #[`item.items`]="{ item }">
            <div class="pa-2">
              <v-simple-table style="border: 1px solid #858585;">
                <thead>
                  <tr>
                    <th>Photo</th>
                    <th>Product</th>
                    <th>Qty</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(line, index) of item.reverseOrderLines"
                    :key="`${item.returnId}-${index}`">
                    <td>
                      <v-img
                        v-if="line.product"
                        :src="line.product.mainImageUrls[0]"
                        width="100"
                        height="100"
                        contain
                        class="my-2" />
                      <span v-else>
                        {{ line.productDTO.productId }}
                      </span>
                    </td>
                    <td class="text-left">
                      <div class="d-flex flex-column">
                        <span v-if="line.product">
                          {{ line.product.name }}
                        </span>
                        <span>
                          {{ line.sellerSkuId }}
                        </span>
                      </div>
                    </td>
                    <td>1</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog
      v-model="showDialogSyncReturnOrder"
      max-width="500px">
      <v-card>
        <v-card-title class="headline">
          Sync Return Order
        </v-card-title>
        <v-card-text>
          <p class="pa-0">
            <b> Brand : </b> {{ brandSelected }}
          </p>
          <div
            class="d-flex"
            style="justify-items: center; align-items: center; gap: 1rem;">
            <div style="width: 40%">
              <gw-date-picker
                v-model="syncStartDate"
                :loading="loading"
                label="Start Date" />
            </div>
            <div style="width: 40%">
              <gw-date-picker
                v-model="syncEndDate"
                :loading="loading"
                label="End Date" />
            </div>

            <v-btn
              color="info"
              small
              class="ml-2"
              :loading="loading"
              @click="syncReturnOrder">
              submit
            </v-btn>
          </div>
          <div v-if="syncReturnOrderResult.lazadaOrderCount">
            <p class="pa-0 mb-0">
              <b> Lazada order count : </b> {{ syncReturnOrderResult.lazadaOrderCount }}
            </p>
            <p class="pa-0 mb-0">
              <b> New order count : </b> {{ syncReturnOrderResult.returnCount }}
            </p>
            <p class="pa-0 mb-0">
              <b> Failed count : </b> {{ syncReturnOrderResult.failedCount }}
            </p>
            <p class="pa-0">
              <b> Unknown count : </b> {{ syncReturnOrderResult.unknownCount }}
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ProductAttributeProvider from '@/resources/ProductAttributeProvider'
import LazadaOrderProvider from '@/resources/LazadaOrderProvider'

const ProductAttributeService = new ProductAttributeProvider()
const LazadaOrderService = new LazadaOrderProvider()

export default {
  data () {
    return {
      headers: [
        {
          text: 'Order Id',
          value: 'orderId',
          width: '300px',
          sortable: false
        },
        {
          text: 'Details',
          value: 'detail',
          width: '300px',
          sortable: false
        },
        {
          text: 'Items',
          value: 'items',
          sortable: false,
          align: 'center'
        }
      ],
      items: [],
      inputSearch: '',
      total: 0,
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      loading: false,
      showDialogSyncReturnOrder: false,
      syncReturnOrderResult: {
        lazadaOrderCount: 0,
        returnCount: 0,
        failedCount: 0,
        unknownCount: 0
      },
      brandSelected: 'Gentlewoman',
      allBrand: ['Gentlewoman'],
      syncStartDate: null,
      syncEndDate: null
    }
  },
  watch: {
    'query.page': {
      handler () {
        this.getItems()
      },
      deep: true
    },
    showDialogSyncReturnOrder (val) {
      if (val === false) {
        this.syncReturnOrderResult = {
          lazadaOrderCount: null,
          returnCount: null,
          failedCount: null,
          unknownCount: null
        }
      }
    }
  },
  async mounted () {
    await this.getBrands()
    await this.getItems(true)
  },
  methods: {
    async getBrands () {
      try {
        this.loading = true

        const { data: brands } = await ProductAttributeService.getProductAttribute('brands', {
          limit: 9999,
          sortBy: 'createdAt',
          sortOrder: 'asc'
        })

        this.allBrand = brands.results.map((brand) => brand.name)
      } catch (error) {
        console.error('getBrands', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async getItems (isClear = false) {
      try {
        this.loading = true

        if (isClear) {
          this.items = []
          this.options.page = 1
        }

        const { data } = await LazadaOrderService.getReturnOrders({
            page: this.options.page,
            limit: this.options.itemsPerPage,
            brand: this.brandSelected,
            sortBy: this.options.sortBy[0],
            sortOrder: this.options.sortDesc[0] ? 'desc' : 'asc',
            search: this.inputSearch
          })

        this.items = (data?.results || []).map((item) => ({
            ...item,
            reverseOrderLines: item.reverseOrderLines.map((line) => {
              const product = item.products.find((p) => p.lazadaProductId === line.productDTO?.productId)

              return {
                ...line,
                product
              }
            }),
            returnReasonText: item.reverseOrderLines[0]?.reasonText || '-',
            returnReason: item.reverseOrderLines[0]?.reasonCode || '-',
            returnStatus: item.reverseOrderLines[0]?.reverseStatus || '-'
          }))
        this.total = data?.totalPages || 0
      } catch (error) {
        console.error('getItems', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async syncReturnOrder () {
      try {
        if (!this.syncStartDate || this.syncStartDate === null || !this.syncEndDate || this.syncEndDate === null) {
          this.$store.dispatch('Components/setSnackbar', {
            value: true,
            message: 'Please select start date and end date',
            type: 'error'
          })

          return
        }

        this.loading = true

        const { data } = await LazadaOrderService.syncReturnOrder({
          brand: this.brandSelected,
          startDate: this.syncStartDate,
          endDate: this.syncEndDate
        })

        this.syncReturnOrderResult = {
          lazadaOrderCount: data.lazadaOrderCount,
          returnCount: data.processedOrders.length,
          failedCount: data.failedOrders.length,
          unknownCount: data.unknownOrders.length
        }
      } catch (error) {
        console.error('syncReturnOrder', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  position: sticky;
  top: 70px;
  left: 0;
  width: 100%;
  z-index: 5;
  background-color: #fff;
  padding: 1.25rem 1.875rem;
  border-radius: 0.625rem;
}
.toolbar span {
  font-weight: bold;
  font-size: 1.25rem;
}
.card-container {
  padding: 1.25rem 1.875rem;
  background-color: #fff;
  border-radius: 0.625rem;
  margin-top: 1.25rem;
  min-height: calc(100vh - 200px);
}
.card-title {
  font-weight: bold;
  font-size: 1.35rem;
}
.paginate-container {
  padding: 0.25rem;
  background-color: #fff;
  border-radius: 1rem;
  margin-top: 0.5rem;
}
</style>

<style>
.search-box .v-input__control {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
.search-box .v-input__slot {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
</style>
